/**
 * Switches de secciones del sitio.
 *
 * La home V4 arranca con promociones, así que "Productos destacados" queda
 * apagada. El componente y la query de Gatsby siguen en su lugar
 * (`src/components/home/FeaturedProducts.jsx` + la query de `src/pages/index.jsx`):
 * poner este flag en `true` alcanza para volver a mostrar la sección.
 */
export const SHOW_FEATURED_PRODUCTS = false;
